import { api } from "./api";

let deferredPrompt = null;
const listeners = new Set();
const emit = () => listeners.forEach((fn) => fn());

export const onInstallChange = (fn) => { listeners.add(fn); return () => listeners.delete(fn); };
export const canPromptInstall = () => !!deferredPrompt;
export const isStandalone = () => window.matchMedia?.("(display-mode: standalone)").matches || window.navigator.standalone === true;
export const isIos = () => /iphone|ipad|ipod/i.test(navigator.userAgent) || (navigator.platform === "MacIntel" && navigator.maxTouchPoints > 1);

export const promptInstall = async () => {
  if (!deferredPrompt) {
    return "unavailable";
  }
  deferredPrompt.prompt();
  const { outcome } = await deferredPrompt.userChoice;
  deferredPrompt = null;
  emit();
  return outcome;
};

export function registerPwa() {
  window.addEventListener("beforeinstallprompt", (e) => { e.preventDefault(); deferredPrompt = e; emit(); });
  window.addEventListener("appinstalled", () => { deferredPrompt = null; emit(); });
  if ("serviceWorker" in navigator) {
    window.addEventListener("load", () => { navigator.serviceWorker.register("/sw.js").catch(() => {}); });
  }
}

export const pushSupport = () => {
  if (!("serviceWorker" in navigator) || !("PushManager" in window) || !("Notification" in window)) {
    return isIos() && !isStandalone() ? "ios-install" : "unsupported";
  }
  return Notification.permission === "denied" ? "denied" : "ok";
};

const toKey = (b64) => {
  const pad = "=".repeat((4 - (b64.length % 4)) % 4);
  const raw = atob((b64 + pad).replace(/-/g, "+").replace(/_/g, "/"));
  return Uint8Array.from([...raw].map((c) => c.charCodeAt(0)));
};

export const currentSubscription = async () => {
  if (pushSupport() !== "ok") {
    return null;
  }
  const reg = await navigator.serviceWorker.getRegistration();
  return reg ? reg.pushManager.getSubscription() : null;
};

export const enablePush = async () => {
  const { data: cfg } = await api.get("/push/config");
  if (!cfg.enabled) {
    throw new Error("Les notifications push ne sont pas disponibles sur ce serveur.");
  }
  const permission = await Notification.requestPermission();
  if (permission !== "granted") {
    throw new Error("Autorisation refusée : aucune notification push ne sera envoyée sur cet appareil.");
  }
  const reg = await navigator.serviceWorker.register("/sw.js");
  await navigator.serviceWorker.ready;
  const sub = (await reg.pushManager.getSubscription()) || (await reg.pushManager.subscribe({ userVisibleOnly: true, applicationServerKey: toKey(cfg.public_key) }));
  const json = sub.toJSON();
  await api.post("/push/subscriptions", { endpoint: json.endpoint, keys: json.keys, device: navigator.userAgent.slice(0, 120) });
  return sub;
};

export const disablePush = async () => {
  const sub = await currentSubscription();
  if (!sub) {
    return;
  }
  try { await api.post("/push/subscriptions/remove", { endpoint: sub.endpoint }); } catch (e) { /* session may already be closed */ }
  await sub.unsubscribe();
};
